import { createTheme } from '@mui/material/styles';
import { getTokens } from './tokens';

export function buildMuiTheme(mode) {
  const t = getTokens(mode);

  return createTheme({
    palette: {
      mode,
      background: {
        default: t.surfaceBase,
        paper: t.surfaceRaised,
      },
      text: {
        primary: t.inkPrimary,
        secondary: t.inkSecondary,
        disabled: t.inkMuted,
      },
      primary: {
        main: t.accent,
        contrastText: mode === 'dark' ? t.surfaceBase : t.inkPrimary,
      },
      error: { main: t.signalError },
      success: { main: t.signalSuccess },
      warning: { main: t.signalWarning },
      divider: t.borderSubtle,
      action: {
        hover: t.surfaceHover,
        selected: t.surfaceHover,
        active: t.inkSecondary,
      },
    },
    shape: { borderRadius: 4 },
    typography: {
      fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            background: t.surfaceRaised,
            border: `1px solid ${t.borderSubtle}`,
            borderRadius: 4,
            color: t.inkPrimary,
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: { root: { color: t.inkPrimary } },
      },
      MuiDialogContent: {
        styleOverrides: { root: { color: t.inkSecondary } },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: t.inkMuted,
            '&.Mui-focused': { color: t.accent },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            color: t.inkPrimary,
            '& .MuiOutlinedInput-notchedOutline': { borderColor: t.borderStrong },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: t.borderStrong },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: t.accent },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          icon: { color: t.inkMuted },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            background: t.surfaceOverlay,
            border: `1px solid ${t.borderSubtle}`,
            color: t.inkPrimary,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: t.inkSecondary,
            '&:hover': { background: t.surfaceHover, color: t.inkPrimary },
            '&.Mui-selected': { background: t.surfaceHover, color: t.inkPrimary },
            '&.Mui-selected:hover': { background: t.surfaceHover, color: t.inkPrimary },
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            background: t.surfaceHover,
            border: `1px solid ${t.borderStrong}`,
            color: t.inkPrimary,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontWeight: 500 },
        },
      },
    },
  });
}
